export const QtplanLogo = ({ size = 20, className }: { size?: number; className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
  >
    <g fill="currentColor">
      <polygon points="50,15 65,45 35,45" />
      <polygon points="31,53 46,53 46,85 15,85" />
      <polygon points="54,53 69,53 85,85 54,85" />
    </g>
  </svg>
);
